


























import { Component, Vue, Watch, Prop, Model } from 'vue-property-decorator';

/**
 * Types
 */
export interface FilterModel {
	selection: any;
	predicate: (x: any) => boolean;
}

/**
 * Composant de filtrage de données d'entrée Array.
 */
@Component
export default class FilterControl extends Vue {
	/** Propriétés */
	@Prop({ default: true })
	displayResetAllFilters!: boolean;

	@Prop()
	filtersDefinitions!: any;

	@Prop({ default: 4 })
	dividingSize!: number;

	/** v-model */
	@Model('filter-changed')
	filterModel!: FilterModel;

	/** Attributs */
	sel: any = this.filterReset();

	/** Méthodes */
	async created() {
		this.resetFilters();
	}

	filterReset() {
		return Object.keys(this.filtersDefinitions).reduce((acc, curr) => ({ ...acc, [curr]: undefined }), {});
	}

	changeSelect(label: string) {
		this.emitChanged();
	}

	resetFilters() {
		this.sel = this.filterReset();
		this.emitChanged();
	}

	emitChanged() {
		this.$emit('filter-changed', {
			selection: this.sel,
			predicate: this.getFilterPredicate()
		});
	}

	getFilterPredicate(): (x: any) => boolean {
		return Object.keys(this.sel).reduce(
			(acc, currKey) => {
				const filterDefinition = this.filtersDefinitions[currKey];
				const keySelected = this.sel[currKey];
				return (x: any) =>
					acc(x)
					&& (
						(keySelected != null && keySelected !== "-1" && filterDefinition != null)
							? filterDefinition.f(keySelected)(x)
							: true
					);
			},
			(x: any) => true
		);
	}

	get containsFilter() {
		return Object.keys(this.sel).find((k) => this.sel[k] !== undefined) != null;
	}
}
